import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=244a15a9&scoped=true&"
import script from "./ProjectInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&id=244a15a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a15a9",
  null
  
)

export default component.exports